export enum TradingProcedureTypeDto {
    English = 'English',
    Sealed = 'Sealed',
}

